import React from 'react'
import SupportSection from '../components/support/SupportSection'

export async function getStaticProps() {
  const content = `
    <div>
      <span>Through customized, on-demand, in-home beauty services, Glamsquad was created to empower our community of clients and beauty pros. We know the positive and inspiring impact our services can have on everyone and we are dedicated to providing a safe experience, free of harassment for everyone in our community. We expect our clients and beauty pros to be treated equally and with respect, regardless of gender, gender identity and expression, sexual orientation, disability, physical appearance, body size, race, ethnicity, age, family structure, socio-economic status or religion.</span>
      <h3>WHEN YOU BOOK WITH GLAMSQUAD</h3>
      <ul style='list-style:initial;'>
        <li>You contribute to a community that puts people first and where everyone is treated with kindness, care, and respect.</li>
        <li>You treat each other&rsquo;s property like it&rsquo;s your own.</li>
        <li>You are ready to start your service at the time of your booked appointment.</li>
        <li>Your home will be treated like a sacred space.</li>
        <li>You respect personal differences and keep judgments to yourself.</li>
        <li>You keep any illegal substances out of the Glamsquad experience.</li>
      </ul>

      <h3>DOING OUR PART</h3>
      <ul style='list-style:initial;'>
        <li>We treat each other and our community respectfully, courteously and with dignity.</li>
        <li>We are fair and honest in our interactions.</li>
        <li>We are responsible for our actions and accountable for their consequences.</li>
        <li>We respect the law and act accordingly.</li>
      </ul>

      <h3>RAISING A CONCERN</h3>
      <span style='font-weight:bold; margin-bottom: 20px;'>Please reach out to us at info@glamsquad.com with the subject line &ldquo;Community Guidelines&rdquo; if any of the following happens:</span>
      <ul style='list-style:initial;'>
        <li>Someone makes you feel unsafe or uncomfortable at a Glamsquad service or Glamsquad event.</li>
        <li>You are experiencing or witnessing any inappropriate or concerning behavior in a Glamsquad service or at a Glamsquad event.</li>
        <li>Someone lets you know that they are uncomfortable about another person&rsquo;s behavior in a Glamsquad service or at a Glamsquad event.</li>
      </ul>

      <span>We will prioritize your complaint with seriousness and in strict confidence.</span>
    </div>`;

  return {
    props: {
      content,
    },
  };
}
``

const CommunityGuidelines = ({ content }) => {
  return (
    <SupportSection
      title='Community Guidelines'
      lastReviewedDate='March 8, 2022'
      content={content}
    />
  )
}

export default CommunityGuidelines